import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Restangular, RestangularModule} from "ngx-restangular";
import {TosterMessageService} from "./toster-message.service";

@Injectable()
export class DashboardService {

  constructor(private restangular: Restangular, private http: HttpClient,
              private tosterMessageService: TosterMessageService) {
  }

  public userWidgetCreate() {
    return this.restangular.all("user_dashboard_masters");
  }

  public defaultWidgetCreate() {
    return this.restangular.all("default_dashboard_masters");
  }


  public dashboardAssignedTabs(companyID) {
    return this.restangular.one("user_dashboard_masters/" + companyID);
  }

  
  public defaultDashboardAssignedTabs(companyID) {
    return this.restangular.one("default_dashboard_masters/" + companyID);
  }

  public getAllRecords() {
    return this.restangular.one("getAllDashboardWidgets");
  }

  public dashboardAssignedWidgets(id) {
    return this.restangular.one("user_dashboard_widgets/" + id);
  }

  public defaultDashboardAssignedWidgets(id) {
    return this.restangular.one("default_dashboard_widgets/" + id);
  }

  public loadWeightLossCategoryChart() {
    return this.restangular.all("loadWeightLossCategoryChart");
  }

  public failureGroupChart() {
    return this.restangular.all("failureGroupChart");
  }

  public countrywiseListWidget() {
    return this.restangular.all("countryWiseList");
  }

  public serverityChart() {
    return this.restangular.all("serverityChart");
  }

  public funnelserverityChart() {
    return this.restangular.all("funnelserverityChart");
  }

  public countryWiseCountChart() {
    return this.restangular.all("countryWiseCountChart");
  }

  public user_dashboard_masters(companyID) {
    return this.restangular.one("user_dashboard_masters/" + companyID);
  }

  public loadLocationWiseChart() {
    return this.restangular.all("locationWiseChart");
  }

  public apcHseChart() {
    return this.restangular.all('apcHseChart');
  }

  public nesrHseChart() {
    return this.restangular.all('nesrHseChart');
  }



  public loadtotalincidentRate() {
    return this.restangular.all("loadtotalincidentRate");
  }

  public getwidgetDropdown() {
    return this.restangular.one("getwidgetDropdown");
  }

  public getwidgetDropdownProjects() {
    return this.restangular.one("getwidgetDropdownProjects");
  }


  public widgetRilrDrillDownCountry() {
    return this.restangular.all("widgetRilrDrillDownCountry");
  }

  public widgetCorrectiveActionDrillDown() {
    return this.restangular.all("widgetCorrectiveActionDrillDown");
  }

  public widgetCorrectiveActionDrillDownAlmaha() {
    return this.restangular.all("widgetCorrectiveActionDrillDownAlmaha");
  }

  public loadinjuredWidgetBodypart() {
    return this.restangular.all("loadinjuredWidgetBodypart");
  }

  public getRilrSummaryCount() {
    return this.restangular.all("getRilrSummaryCount");
  }

  public getActionSummaryCount() {
    return this.restangular.all("getActionSummaryCount");
  }




  public getAlmahaRilrSummaryCount() {
    return this.restangular.all("getAlmahaRilrSummaryCount");
  }

  public getWidgetActionItems() {
    return this.restangular.all("getWidgetActionItems");
  }

  public getWidgetAllActionItems() {
    return this.restangular.all("getWidgetAllActionItems");
  }

  public getAllWidgetsCompanyBase() {
    return this.restangular.one("getAllWidgetsCompanyBase");
  }

  public serverityChartHSEAlkhoreyf() {
    return this.restangular.all("serverityChartHSEAlkhoreyf");
  }

  public serverityChartPQAlkhoreyf() {
    return this.restangular.all("serverityChartPQAlkhoreyf");
  }

  public regionWiseListWidget() {
    return this.restangular.all("regionWiseList");
  }

  public regionWiseListBarWidget() {
    return this.restangular.all("regionWiseListBarWidget");
  }

  public regionWisePieChartWidget() {
    return this.restangular.all("regionWisePieChartWidget");
  }

  public pyramidChartAccidentAlkhoreyf() {
    return this.restangular.all("pyramidChartAccidentAlkhoreyf");
  }


  public pyramidChartSeverityAlkhoreyf() {
    return this.restangular.all("pyramidChartSeverityAlkhoreyf");
  }




  public pyramidChartRilrAlkhoreyf() {
    return this.restangular.all("pyramidChartRilrAlkhoreyf");
  }

  public typePieChartAccidentAlkhoreyf() {
    return this.restangular.all("typePieChartAccidentAlkhoreyf");
  }

  public incidentTypePieChartAccidentAlkhoreyf() {
    return this.restangular.all("incidentTypePieChartAccidentAlkhoreyf");
  }

  public accidentInjuryOutcomeNesr() {
    return this.restangular.all("accidentInjuryOutcomeNesr");
  }

  public rootCausesPieChartAccidentAlkhoreyf() {
    return this.restangular.all("rootCausesPieChartAccidentAlkhoreyf");
  }

  public rootCausesPieChartNCRAlkhoreyf() {
    return this.restangular.all("rootCausesPieChartNCRAlkhoreyf");
  }

  public severityChartIncidentAlmaha() {
    return this.restangular.all("severityChartIncidentAlmaha");
  }

  public incidentLikelihoodPieAlmaha() {
    return this.restangular.all("incidentLikelihoodPieAlmaha");
  }

  public incidentRegionWiseListAlmaha() {
    return this.restangular.all("incidentRegionWiseListAlmaha");
  }

  public getCurrentCompanyDetail() {
    return this.restangular.one("getCurrentCompanyDetail");
  }

  public summaryNCRChartAlkhorayef() {
    return this.restangular.all("summaryNCRChartAlkhorayef");
  }

  public typeOfEventChartNCRAlkhoreyf() {
    return this.restangular.all("typeOfEventChartNCRAlkhoreyf");
  }

  public categorySummaryNCRAlkhoreyf() {
    return this.restangular.all("categorySummaryNCRAlkhoreyf");
  }

  public monthlySafetyChart() {
    return this.restangular.all('monthlySafetyChart');
  }

  public monthlySafetyChartSummary() {
    return this.restangular.all('monthlySafetyChartSummary');
  }

  public loadLtifrChart() {
    return this.restangular.all("loadLtifrChart");
  }

  public supplierChartNCRAlkhoreyf() {
    return this.restangular.all("supplierChartNCRAlkhoreyf");
  }

  public supplierCountChartNCRAlkhoreyf() {
    return this.restangular.all("supplierCountChartNCRAlkhoreyf");
  }

  public summaryNCRPlantRootCauseChartAlkhorayef() {
    return this.restangular.all("summaryNCRPlantRootCauseChartAlkhorayef");
  }

  public categoryRIRAlkhoreyfChart() {
    return this.restangular.all("categoryRIRAlkhoreyfChart");
  }

  public observationRIRAlkhoreyfChart() {
    return this.restangular.all("observationRIRAlkhoreyfChart");
  }

  public classificationOfAuditAlmaha() {
    return this.restangular.all("classificationOfAuditAlmaha");
  }

  public totalNumberOfFindingsAlmaha() {
    return this.restangular.all("totalNumberOfFindingsAlmaha");
  }

  public totalNumberOfFindingsBarChartAlmaha() {
    return this.restangular.all("totalNumberOfFindingsBarChartAlmaha");
  }

  public closureStatusOfFindingsAlmaha() {
    return this.restangular.all("closureStatusOfFindingsAlmaha");
  }

  public findingDeviationAuditAlmaha() {
    return this.restangular.all("findingDeviationAuditAlmaha");
  }

  public closureFindingsRegionAlmaha() {
    return this.restangular.all("closureFindingsRegionAlmaha");
  }

  public monthlySafetyPyramidAlmaha() {
    return this.restangular.all("monthlySafetyPyramidAlmaha");
  }

  public hseReportSummaryAlmaha() {
    return this.restangular.all("hseReportSummaryAlmaha");
  }

  public inspectionRegionWiseListAlmaha() {
    return this.restangular.all("inspectionRegionWiseListAlmaha");
  }

  public totalReportMonthWiseBarChartAlmaha() {
    return this.restangular.all('totalReportMonthWiseBarChartAlmaha');
  }

  public incidentReportTrendAlmaha() {
    return this.restangular.all('incidentReportTrendAlmaha');
  }

  public incidentReportPatternAlmaha() {
    return this.restangular.all('incidentReportPatternAlmaha');
  }

  public monthlySafetyChartSummaryAlmaha() {
    return this.restangular.all('monthlySafetyChartSummaryAlmaha');
  }

  public tankerInspectionSummaryAlmaha() {
    return this.restangular.all('tankerInspectionSummaryAlmaha');
  }

  public correctiveActionRegionWiseListAlmaha() {
    return this.restangular.all("correctiveActionRegionWiseListAlmaha");
  }

  public inspectionCARegionWiseListAlmaha() {
    return this.restangular.all("inspectionCARegionWiseListAlmaha");
  }

  public reportsDrillDown() {
    return this.restangular.all("reportsDrillDown");
  }

  public rirFieldQualityFailedAlkhoreyf() {
    return this.restangular.all("rirFieldQualityFailedAlkhoreyf");
  }

  public rirFieldQualityFailedCostAlkhoreyf() {
    return this.restangular.all("rirFieldQualityFailedCostAlkhoreyf");
  }

  public monthlyHseEsgChart() {
    return this.restangular.all('monthlyHseEsgChart');
  }

  public nesrEsgTrendChart() {
    return this.restangular.all('nesrEsgTrendChart');
  }

  public nesrManHoursTrendChart() {
    return this.restangular.all('nesrManHoursTrendChart');
  }

  public monthlySafetyChartSummaryNesr() {
    return this.restangular.all('monthlySafetyChartSummaryNesr');
  }

  public nesrAccidentSeniorityChart() {
    return this.restangular.all("nesrAccidentSeniorityChart");
  }

  public incidentTypePieChartRilr() {
    return this.restangular.all("incidentTypePieChartRilr");
  }

  public rirAndRilrTrenChart() {
    return this.restangular.all('rirAndRilrTrenChart');
  }

  public assignDashboardToEmployees() {
    return this.restangular.all('assignDashboardToEmployees');
  }

  getUserTypes() {
    return this.restangular.one('user_types');
  }

  getDashboardAssignedEmployees() {
    return this.restangular.all('getDashboardAssignedEmployees');
  }
  
  getDashboardEmployeesFormData() {
    return this.restangular.one('getDashboardEmployeesFormData');
  }


  
 getManhours() {
    return this.restangular.all("man-hours");
  }


  getManhoursSearch() {
    return this.restangular.all("getManhoursSearch");
  }




  getManHoursByLocationID() {
    return this.restangular.one("getManHoursByLocationID");
  }

   getManHoursByMonth() {
    return this.restangular.all("getManHoursByMonth");
  }

  getManHoursByMonthSearch() {
    return this.restangular.all("getManHoursByMonthSearch");
  }

  getManHoursByYearSearch() {
    return this.restangular.all("getManHoursByYearSearch");
  }

  getLahidhByMonthSearch() {
    return this.restangular.all("getLahidhByMonthSearch");
  }

  getLahidhByWeekSearch() {
    return this.restangular.all("getLahidhByweekSearch");
  }


  getAllIcamDashboardReports() {
    return this.restangular.all('getAllIcamDashboardReports');
  }




    //rigsbymonth

    public rigsbymonth() {
      return this.restangular.all('rigsbymonth');
    }
  

}



// WEBPACK FOOTER //
// /app/src/app/services/dashboard.service.ts